import {
  CostCentersValueObjectsCostCenterStatusEnum,
  CostCentersValueObjectsStructureEnum,
  CostCentersValueObjectsStructureTypeEnum,
} from 'generated/resources/graphql'

export const COST_CENTER_STATUS: Record<
  CostCentersValueObjectsCostCenterStatusEnum,
  CostCentersValueObjectsCostCenterStatusEnum
> = {
  active: 'active',
  inactive: 'inactive',
} as const

export const COST_CENTER_STRUCTURE: Record<
  CostCentersValueObjectsStructureEnum,
  CostCentersValueObjectsStructureEnum
> = {
  job_catalog_family: 'job_catalog_family',
  job_catalog_function: 'job_catalog_function',
  job_catalog_role: 'job_catalog_role',
  workplace: 'workplace',
} as const

export const COST_CENTER_STRUCTURE_TYPES: Record<
  CostCentersValueObjectsStructureTypeEnum,
  CostCentersValueObjectsStructureTypeEnum
> = {
  job_catalog: 'job_catalog',
  workplace: 'workplace',
} as const
